import PubSub from "underpub-js";
import Cocoen from "cocoen";
import Plyr from 'plyr/dist/plyr.polyfilled.js';
import Aframe from 'aframe';

var MapProjectMapWithInfoPopups = function(options) {

	this.options = {
		$el: false
	};

  $.extend(true, this.options, options);

};

MapProjectMapWithInfoPopups.prototype.init = function() {

	var self = this;

	// init popups
	this.initInfoPopups();
	this.initImagePopups();
	this.initBeforeAfterImagePopups();
	this.init360ImagePopups();
	this.initVideoPopups();
	this.initMatterportPopups();

};

MapProjectMapWithInfoPopups.prototype.initInfoPopups = function() {

	var self = this;

	this.positionInfoPopups();

	$(window).on('load', function() {
		self.positionInfoPopups();
	});

	PubSub.subscribe("resized", function(){
		self.positionInfoPopups();
	});

	this.options.$el.find('.info-marker').on({

		// open popup on hover on all screen sizes
		// note: hover is the same as click on mobile
		mouseenter: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{

				var $popup = $( '#' + $(this).data('popupId') );

				$popup.addClass('active');
				$(this).addClass('active');

			}

		},

		// only close on mouse leave for large screens,
		// for mobile we will use the close X
		mouseleave: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{
				var $popup = $( '#' + $(this).data('popupId') );

				if (!$popup.is(':hover'))
				{
					$popup.removeClass('active');
					$(this).removeClass('active');
				}
			}

		},

		// react to click event as well in case mouseenter doesn't register in mobile browser
		click: function() {

			var $popup = $( '#' + $(this).data('popupId') );

			$popup.addClass('active');
			$(this).addClass('active');

		}

	});

	this.options.$el.find('.info-popup-wrapper').on({

		// only close on mouse leave for large screens,
		// for mobile we will use the close X
		mouseleave: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{
				var $popupMarker = $( '.info-marker[data-popup-id="' + $(this).attr('id') + '"]');

				if (!$popupMarker.is(':hover'))
				{
					$(this).removeClass('active');
					$popupMarker.removeClass('active');
				}
			}

		}

	});

	// on mobile, close the info popup when the close X is clicked
	this.options.$el.find('.info-popup-wrapper .close-x').on('click', function() {

		if (Breakpoint.value == "xsmall" ||
			Breakpoint.value == "small")
		{
			var $popupWrapper = $(this).closest('.info-popup-wrapper');
			var popupId = $popupWrapper.attr('id');
			var $popupMarker = $('.info-marker[data-popup-id="' + popupId + '"]');

			$popupWrapper.removeClass('active');
			$popupMarker.removeClass('active');
		}

	});

};

MapProjectMapWithInfoPopups.prototype.initImagePopups = function(){

	var self = this;

	this.options.$el.find('.image-popup-marker, .drone-image-popup-marker').on('click', function() {

		var $popup = $( '#' + $(this).data('popupId') );
		$popup.addClass('active');
		$(this).addClass('active');

	});

	this.options.$el.find('.image-popup .close-x').on('click', function() {

		var $popup = $(this).closest('.image-popup');
		var $popupMarker = $popup.prev();
		$popup.removeClass('active');
		$popupMarker.removeClass('active');

	});

};

MapProjectMapWithInfoPopups.prototype.initBeforeAfterImagePopups = function(){

	var self = this;

	this.options.$el.find('.before-after-image-popup').each(function() {

		new Cocoen($(this).find(".cocoen")[0]);

	});

	this.options.$el.find('.before-after-image-popup-marker').on('click', function() {

		var $popup = $( '#' + $(this).data('popupId') );
		$popup.addClass('active');
		$(this).addClass('active');

	});

	this.options.$el.find('.before-after-image-popup .close-x').on('click', function() {

		var popupId = $(this).closest('.before-after-image-popup').attr('id');
		var $popupMarker = self.options.$el.find('.before-after-image-popup-marker[data-popup-id="' + popupId + '"]');
		$(this).closest('.before-after-image-popup').removeClass('active');
		$popupMarker.removeClass('active');

		setTimeout(function() {
			self.options.$el.find('#' + popupId + ' .cocoen-drag').css('left', '');
			self.options.$el.find('#' + popupId + ' div').css('width', '');
		}, 450);

	});

};

MapProjectMapWithInfoPopups.prototype.init360ImagePopups = function(){

	var self = this;

	this.options.$el.find('.image-360-popup').each(function() {

		// note - we're injecting the scenes into the page here because
		// a-frame won't work properly if the scene is in the HTML before
		// the a-frame script.

		var imageUrl = $(this).data('imageUrl');
		var scene = self.getScene(imageUrl);

		$(this).find('.a-frame-scene-wrapper').append(scene);

	});

	this.options.$el.find('.image-360-popup-marker').on('click', function() {

		var $popup = $( '#' + $(this).data('popupId') );
		$popup.addClass('active');
		$(this).addClass('active');

	});

	this.options.$el.find('.image-360-popup .close-x').on('click', function() {

		var $popup = $(this).closest('.image-360-popup');
		var $popupMarker = $popup.prev();
		$popup.removeClass('active');
		$popupMarker.removeClass('active');

	});

};

MapProjectMapWithInfoPopups.prototype.initVideoPopups = function(){

	var self = this;

	this.options.$el.find('.drone-video-popup').each(function() {

		var $videoPlayer = $(this).find('.video-player');

		var player = new Plyr( $videoPlayer, {
			enabled: true,
			controls: ['progress'],
			settings: ['captions', 'quality', 'speed', 'loop'],
			autoplay: false,
			muted: false,
			clickToPlay: true,
			hideControls: false,
			resetOnEnd: false,
			ratio: null, // The format is 'w:h' - e.g. '16:9' or '4:3'. HTML5 and Vimeo detect ratio automatically, youtube defaults to 16:9
		} );

		$(this).find('.play-button').on('click', function() {

			if ($(this).hasClass('playing'))
			{
				player.pause();
			}
			else
			{
				player.play();
			}

		});

		player.on('playing', event => {

			const instance = event.detail.plyr;
			
			$(this).find('.play-button').removeClass('paused').addClass('playing');

			$(this).removeClass('paused').addClass('playing');

		});

		player.on('pause', event => {

			const instance = event.detail.plyr;
			
			$(this).find('.play-button').removeClass('playing').addClass('paused');

			$(this).removeClass('playing').addClass('paused');

		});

		$(this).find('.close-x').on('click', function() {

			player.pause();
			var $popup = $(this).closest('.drone-video-popup');
			var $popupMarker = $popup.prev();
			$popup.removeClass('active');
			$popupMarker.removeClass('active');

		});

	});

	this.options.$el.find('.drone-video-popup-marker').on('click', function() {

		var $popup = $( '#' + $(this).data('popupId') );
		$popup.addClass('active');
		$(this).addClass('active');

	});

};

MapProjectMapWithInfoPopups.prototype.initMatterportPopups = function(){

	var self = this;

	this.options.$el.find('.matterport-popup-marker').on('click', function() {

		var $popup = $( '#' + $(this).data('popupId') );
		$popup.addClass('active');
		$(this).addClass('active');

	});

	this.options.$el.find('.matterport-popup .close-x').on('click', function() {

		var $popup = $(this).closest('.matterport-popup');
		var $popupMarker = $popup.prev();
		$popup.removeClass('active');
		$popupMarker.removeClass('active');

	});

};

MapProjectMapWithInfoPopups.prototype.getScene = function(imageSrc){

	return `
		<a-scene embedded="true">
			<a-sky src="` + imageSrc + `" rotation="0 -130 0"></a-sky>
		</a-scene>
	`;

};

MapProjectMapWithInfoPopups.prototype.positionInfoPopups = function() {

	var self = this;

	this.options.$el.find('.info-popup-wrapper').each(function() {

		// reset everything
		$(this).find('.arrow').css('left', '');
		$(this).removeClass('arrow-flipped');
		$(this).css({
			'left': '',
			'top': '',
		});
		$(this).find('.arrow').css({
			'left': '',
		});

		if (Breakpoint.value == "medium" ||
			Breakpoint.value == "large" ||
			Breakpoint.value == "xlarge" ||
			Breakpoint.value == "xxlarge")
		{
			// get our bounding rectangles
			var containerBoundingRect = self.options.$el.find('.image-container')[0].getBoundingClientRect();

			var popupBoundingRect = $(this)[0].getBoundingClientRect();

			var popupTopAdjust = popupBoundingRect.height + 8; // adding 8 to get the popup past the top of the marker
			var popupHalfWidth = popupBoundingRect.width / 2

			// initial popup position
			// left - use marker percentage, pull 135px left 
			// right - use marker percentage, pull up height + 8
			$(this).css({
				'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px)',
				'top': 'calc(' + $(this).data('y') + '% - ' + popupTopAdjust + 'px)',
			});
			
			// after initial positioning, update the popup bounding rectangle
			popupBoundingRect = $(this)[0].getBoundingClientRect();

			// make sure our popup is still contained inside the component

			// left side
			if (popupBoundingRect.left < containerBoundingRect.left)
			{

				// the popup is outside the left edge, adjust to move it back in
				var leftAdjust = containerBoundingRect.left - popupBoundingRect.left + 6;

				$(this).css({
					'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px + ' + leftAdjust + 'px)',
				});

				// adjust the arrow so it still points to the marker
				$(this).find('.arrow').css({
					'left': 'calc(50% - 14px - ' + leftAdjust + 'px)',
				});

			}

			// right side
			if (popupBoundingRect.right > containerBoundingRect.right)
			{

				// the popup is outside the left edge, adjust to move it back in
				var rightAdjust = popupBoundingRect.right - containerBoundingRect.right + 6;

				$(this).css({
					'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px - ' + rightAdjust + 'px)',
				});

				// adjust the arrow so it still points to the marker
				$(this).find('.arrow').css({
					'left': 'calc(50% - 14px + ' + rightAdjust + 'px)',
				});

			}

			// top
			if ((popupBoundingRect.top - 10) < containerBoundingRect.top) // subtract ten from bounding rect to account for translateY
			{

				// the popup is outside the top edge, adjust to move it back in

				// flip the arrow so it points up
				$(this).addClass('arrow-flipped');

				// use percentage, pull down 8px to give some space around marker
				$(this).css({
					'top': 'calc(' + $(this).data('y') + '% + 8px)',
				});

			}

		}

	});

};

export default MapProjectMapWithInfoPopups;
